import React, { useState } from 'react'
import { AiOutlineLock } from 'react-icons/ai'
import { BsFillPersonFill } from 'react-icons/bs'
import { HiOutlineChevronRight } from 'react-icons/hi'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ButtonSubmit } from '../../../GlobalStyle'
import api from '../../../hooks/API'
import InputComponent from '../../components/Input'
import BaseLogin from '../index'
import { IconInput, Infos, InputContainer, NewUser } from '../style'
import { Back, ButtonBack } from './style'

const ResetPassword = () => {
  const navigate = useNavigate()
  const handle = async (e) => {
    e.preventDefault()

    await api
      .forgotPassword({ email: email })
      .then(() => {
        toast.success('Link enviado com sucesso, cheque seu email')
        navigate(-1)
      })
      .catch((e) => {
        toast.error(e.message)
      })
  }
  const [email, setEmail] = useState()
  return (
    <BaseLogin>
      <Infos>
        <AiOutlineLock />
        <h2>Esqueceu a senha</h2>
        <p>Digite seu email e um link será enviado para redefinição da senha</p>
      </Infos>
      <InputContainer>
        <IconInput>
          <BsFillPersonFill />
        </IconInput>

        <InputComponent
          login={'login'}
          name="name"
          placeholder="Email"
          onChange={(e) => setEmail(e.target.value)}
        />
      </InputContainer>

      <NewUser>
        <ButtonSubmit onClick={handle}>Enviar</ButtonSubmit>
      </NewUser>
      <Back>
        <ButtonBack onClick={() => navigate('/login')}>
          <HiOutlineChevronRight />
          <span> Voltar para o login</span>
        </ButtonBack>
      </Back>
    </BaseLogin>
  )
}

export default ResetPassword
